export default{
    与我们联系:"ติดต่อเรา",
    专属客户经理将尽快联系您:"",
    立即参与:"เข้าร่วมเลย",
}